<h2 mat-dialog-title>
  Очки — {{ data.season.name }} · пользователь {{ data.userId }}
</h2>
<mat-dialog-content
  ><p *ngIf="loading">Загрузка…</p>
  <p class="error" *ngIf="error">{{ error }}</p>
  <button mat-button *ngIf="!loading && !busy" (click)="load()">
    Обновить данные
  </button>
  <form [formGroup]="form" *ngIf="score">
    <mat-form-field *ngFor="let field of fields" appearance="outline"
      ><mat-label>{{ field.label }}</mat-label
      ><input
        matInput
        type="number"
        min="0"
        [max]="field.max"
        step="1"
        [formControlName]="field.key"
        [readonly]="busy"
        [matTooltip]="field.hint"
      /><mat-hint>{{ field.hint }}</mat-hint></mat-form-field
    >
    <mat-form-field appearance="outline"
      ><mat-label>Итого очков</mat-label
      ><input matInput [value]="total" readonly /><mat-hint
        >totalScore — сумма собранных и незабранных очков, рассчитывается
        автоматически.</mat-hint
      ></mat-form-field
    >
    <p>
      Коррекция задаёт новые значения показателей. История квестов и выданных
      наград сохраняется.
    </p>
    <mat-form-field *ngIf="data.canEdit"
      ><mat-label>Причина изменения</mat-label
      ><textarea
        matInput
        formControlName="reason"
        maxlength="1000"
        [readonly]="busy"
      ></textarea
    ></mat-form-field></form
></mat-dialog-content>
<mat-dialog-actions align="end"
  ><button mat-button (click)="ref.close(changed)">Закрыть</button
  ><button
    mat-raised-button
    color="primary"
    *ngIf="data.canEdit && score"
    [disabled]="busy || loading || form.invalid"
    (click)="save()"
  >
    {{ busy ? 'Сохранение…' : 'Сохранить' }}
  </button></mat-dialog-actions
>
